// extracted by mini-css-extract-plugin
export default {"fs":"aeae2c702f _20170a18d2"};